module.exports = __webpack_public_path__ + "static/Iubenda-04b7284fa322c744a46e95f3611f62e3.jpg";